import React from 'react'
import './Main.css'
import asuImg from '../images/asulogo.png'
const Landing = () => {
  return (
    <div className="landingContainer">
    <div className="landingPage">
        <img className="asuLogo" src={asuImg}></img>
        <img className='arrow' src="https://www.altaia.eu/wp-content/uploads/2017/03/006737-3d-transparent-glass-icon-arrows-arrow-thick-down.png"></img>
        <div className='content'>
            <div className="about">
                <h1>Our Club:</h1>
                <p>The Asian Student Union is a group that welcomes students from all ethnic backgrounds and works to conserve and promote Asian culture among its members and the local population.
                </p>          
                <h1>Socials: </h1>
                <p>
                Email: mnhsasu@gmail.com<br/>
                Remind: @mnhsasu to 81010<br/>
                Remind: https://www.remind.com/join/mnhsasu	<br/>
                Insta: @mnhsasu<br/>
                Discord: https://discord.gg/8XQsYBTd<br/>
                </p>
                <h2>Officers: </h2>
                <p>
                President: Andrew Yick<br/>
Vice President: Matthew Nguyen<br/> 
Communications/socials: <br/>
Website Designer: Daniel Hyun

                </p>
                <h2>Meeting Dates: </h2>
                <p>
                   Every Thurs @2:45 - 3:15 in TBA
                </p>
          </div>
        </div>
    </div>
    </div>
  )
}

export default Landing